import React from 'react';
import PropTypes from 'prop-types';
import QuoteView from '../quoteView';
import {
  getMsrpColumnClassNames,
  getDNetColumnClassNames,
} from '../../../quotes/quotePriceMode';
import BuildToOrderLeadTimeLabel from '../../../quotes/lead-times/BuildToOrderLeadTimeLabel';
import ReviewQuoteCustomLineItemPricing from '../../review/quote-products/ReviewQuoteCustomLineItemPricing';

const QuoteCustomLineItem = ({ item, selectedPriceMode, isoCurrencySymbol }) => {

  const msrpClassNames = getMsrpColumnClassNames(selectedPriceMode);
  const dNetClassNames = getDNetColumnClassNames(selectedPriceMode);

  return (
    <tr>
      <td className="text-start product-details">
        <div className="group-name">{item.name}</div>
        <div>{item.basePartNumber}</div>
        <div className="text-break-line">{item.description}</div>
      </td>
      <td data-title="Lead Time" className="lead-time">
        {item.leadTimeDays ? (
          <div className="clearfix lead-time-section">
            <div className="leadtime-days">
              <BuildToOrderLeadTimeLabel leadTimeDays={item.leadTimeDays} />
            </div>
          </div>
        ) : (
          'n/a'
        )}
      </td>
      <td className="price-breakdown">
        {item.pricing && <ReviewQuoteCustomLineItemPricing
          pricing={item.pricing}
          selectedPriceMode={selectedPriceMode}
          isoCurrencySymbol={isoCurrencySymbol}
          msrpClassNames={msrpClassNames}
          dNetClassNames={dNetClassNames}
          quoteCustomLineItem={item}
        />}
      </td>
    </tr>
  );
};

export default class QuoteCustomLineItemsComponent extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    selectedPriceMode: PropTypes.string.isRequired,
  };

  render() {
    const { quote, selectedPriceMode } = this.props;

    const msrpClassNames = getMsrpColumnClassNames(selectedPriceMode);
    const dNetClassNames = getDNetColumnClassNames(selectedPriceMode);

    if (quote.customLineItems.length === 0) return null;
    return (
      <div className="card mb-3 box-shadow">
        <div className="card-body">
          <h6 className="card-title text-center">Custom Line Items</h6>
          <table className="table quote-view-table quote-view-products-table table-mobile">
            <thead>
              <tr>
                <th width="44%" className="text-start">
                  Details
                </th>
                <th width="12%" className="text-center">
                  Lead Time
                </th>
                <th width="44%">
                  <div className="row">
                    <div className="col-6"></div>
                    <div className={msrpClassNames}>MSRP</div>
                    <div className={dNetClassNames}>D. NET</div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {quote.customLineItems.map((item) => (
                <QuoteCustomLineItem
                  key={item.id}
                  item={item}
                  selectedPriceMode={selectedPriceMode}
                  isoCurrencySymbol={quote.isoCurrencySymbol}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
